import { Paper } from "@mui/material";

import { SmartTable } from "src/components/SmartTable";

import { AddressNameLabel } from "@features/addresses";
import Tags from "@features/ui/Tags";

import CompareCosts from "../CompareCosts";
import {
  displayToInventoryAllocation,
  getCoopExtendedCost,
  getCost,
  getExtendedCost,
  getOrderEstimatedShippingCost,
} from "../helpers";
import { useCurrentOrderSet } from "../orderSet/data/CurrentOrderSetContext";

const OrderSetOrdersOverview = () => {
  const { orders, isCoopOrderSet } = useCurrentOrderSet();

  const estLabel = (label: string) =>
    isCoopOrderSet ? label : `Est. ${label}`;

  return (
    <Paper>
      <SmartTable
        rows={orders ?? []}
        columns={[
          { id: "id", label: "Order #" },
          {
            id: "address.name",
            label: "Address",
            render: (value, order) =>
              order.type === "to-inventory" ? (
                <div className="flex gap-2">
                  <Tags.Restock brandFunded={order.isBrandFunded} />
                  <span>{displayToInventoryAllocation(order)}</span>
                </div>
              ) : (
                <AddressNameLabel isForReyes={order.address.isForReyes}>
                  {value}
                </AddressNameLabel>
              ),
          },
          {
            id: "address.abn",
            label: "ABN",
            render: (v) => v || "---",
          },
          {
            id: "_totalEstimatedCost",
            label: estLabel("Cost"),
            align: "right",
            render: (_v, order) => (
              <CompareCosts
                cost={getCost(order.billableTotalEstimatedCost, isCoopOrderSet)}
                comparedTo={order.totalEstimatedCost}
              />
            ),
          },
          {
            id: "_totalEstimatedShippingCost",
            label: estLabel("Freight"),
            align: "right",
            render: (_v, order) => {
              const isInventoryOrder = order.orderingType === "from-inventory";

              return (
                <CompareCosts
                  cost={getCost(
                    order.billableTotalEstimatedShippingCost,
                    isCoopOrderSet && !isInventoryOrder
                  )}
                  comparedTo={getOrderEstimatedShippingCost(order)}
                />
              );
            },
          },
          {
            id: "_totalEstimatedTax",
            label: estLabel("Tax"),
            align: "right",
            render: (_v, order) => (
              <CompareCosts
                cost={getCost(order.billableTotalEstimatedTax, isCoopOrderSet)}
                comparedTo={order.totalEstimatedTax}
              />
            ),
          },
          {
            id: "_extendedTotal",
            label: "Total",
            align: "right",
            render: (_v, o) => {
              const extendedCost = getExtendedCost(o);
              return (
                <CompareCosts
                  cost={
                    isCoopOrderSet
                      ? getCoopExtendedCost(o, o.orderingType)
                      : extendedCost
                  }
                  comparedTo={extendedCost}
                />
              );
            },
          },
        ]}
      />
    </Paper>
  );
};

export default OrderSetOrdersOverview;
